import React, { Component, Fragment, Suspense } from "react";
import TopBar from "./components/TopBar";
import AppRoutes, { RouteNames } from "./components/AppRoutes";
import AppCatalogueRoutes from "./components/AppCatalogueRoutes";
import Footer from "./containers/Footer";
import ScrollToTop from "./components/ScrollToTop";
import UserErrors from "./containers/UserErrors";
import SideMenu from "./containers/SideMenu";
import { BreakpointProvider } from 'react-socks';
import { I18nextProvider } from "react-i18next";
import i18nInit from "./i18n";
import Spinner from './components/Spinner';
import { connect } from "react-redux";
import { getActiveSettings, getSiteLinks } from "./actions/supplierActions";
import { withRouter } from "react-router";
import axios from "axios";
import { utils } from "./common/utils";
import queryString from 'query-string'
import { Helmet } from "react-helmet";
import { getCart, saveCart } from "./actions/cartActions";
import { getTranslations } from "./actions/translationActions";
import _ from 'lodash/core';
import HeadofficeMessage from "./components/HeadofficeMessage";
import AccessDeniedNoHeader from "./components/AccessDeniedNoHeader";
import AccessDeniedView from "./views/AccessDeniedView";
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import CookieConsent from './components/CookieConsent';
//import { CookieTypeEnum } from './common/enums'
import getCookieConfig from './common/cookies'
import ResizeObserver from 'react-resize-observer';
import { xorBy } from "lodash";
 

class App extends Component {
    state = { hasTranslationLoaded: false, i18n: null };
    containerRef = React.createRef();

    // Move default webshop name out off app start as in the case of hard refresh of the page. 
    //at this point react - router matches first on the root node and consider the path url as the shop name match.params.shopName = login or register
    constructor(props) {
        super(props);
        const { shopName } = props.match.params;
        axios.defaults.headers.common['shopName'] = shopName && RouteNames.includes(shopName) === false ? shopName : "";

        const value = queryString.parse(this.props.location.search, { parseBooleans: true });
        if (value && value.iscatalogue && this.isInIframe() === true) {

            axios.defaults.headers.common['ref'] = window.location.pathname;
            axios.interceptors.request.use((config) => {
                config.params = { ...config.params, iscatalogue: 'true' }
                return config
            });
        }
    }



    isInIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    componentDidUpdate() {
        // maintain header sticks 
        const $ = window.$;
        if ($(".navbar-sticky").length) {
            $(window).on("scroll", function () {
                var $body = $("body");
                var $navbar = $(".navbar-sticky");
                var $topbarH = $(".topbar").outerHeight();
                var $navbarH = $navbar.outerHeight();
                if ($(this).scrollTop() > $topbarH) {
                    $navbar.addClass("navbar-stuck");
                    if (!$navbar.hasClass("navbar-ghost")) {
                        $body.css("padding-top", $navbarH);
                    }
                } else {
                    $navbar.removeClass("navbar-stuck");
                    $body.css("padding-top", 0);
                }
            });
        }
    }


    registerAnalytics(settings) {
        if (settings && window.CookieConsentApi.allowedCategory('analytics') === true) {
            this.registerGoogleAnalytics(settings.googleAnalyticsId);
            this.registerGoogleTagManager(settings.googleTagManagerId);
            this.registerFacebookPixel(settings.facebookPixelId);
            this.registerActiveCampaign(settings.activeCampaignId);
        }
    }


    registerGoogleAnalytics(googleAnalyticslId) {
        if (window.ga || utils.isNullOrEmpty(googleAnalyticslId)) {
            return;
        }
        const url = 'https://www.google-analytics.com/analytics.js';
        utils.loadScript(url, function () {
            window.ga = window.ga || function () { (window.ga.q = window.ga.q || []).push(arguments) }; window.ga.l = +new Date;
            window.ga('create', googleAnalyticslId, 'auto');
            window.ga('send', 'pageview');
        });
    }

    registerGoogleTagManager(googleTagManagerId) {
        if (window.gtag || utils.isNullOrEmpty(googleTagManagerId)) {
            return;
        }

        const url = `https://www.googletagmanager.com/gtag/js?id=${googleTagManagerId}`;
        utils.loadScript(url, function () {

            window.dataLayer = window.dataLayer || [];
            window.gtag = window.gtag || function () { window.dataLayer.push(arguments); }
            window.gtag('js', new Date());

            window.gtag('config', googleTagManagerId);

        });
    }

    registerFacebookPixel(facebookPixelId) {
        if (facebookPixelId && window.fbq) {
            window.fbq('init', facebookPixelId);
            window.fbq('track', 'PageView');
        }
    }

    registerActiveCampaign(activeCampaignId) {
        if (activeCampaignId && window.vgo) {
            window.vgo('setAccount', activeCampaignId);
            window.vgo('setTrackByDefault', true);
            window.vgo('process');

            window.vgo('setAccount', activeCampaignId);
            window.vgo('setTrackByDefault', true);
            window.vgo('process');
        }
    }

    registerOpenpayWidgets(settings) {
        if (window.OpenpayWidgets) {
            return;
        }

        const url = `https://widgets.openpay.com.au/lib/openpay-widgets.min.js`;
        utils.loadScript(url, function () {

            window.OpenpayWidgets.Config({
                region: settings.openpayRegion,
                currency: settings.currencySymbol,
                planTiers: settings.openpayPlanTier ? settings.openpayPlanTier.split(',') : [], // [2, 4, 6],
                minEligibleAmount: settings.openpayMinLimit,
                maxEligibleAmount: settings.openpayMaxLimit,
                type: 'Online'
            });

        });
    }


    checkAnonymouse(settings, location, checkSessionValidity = false) {
        let allowedAnonymousRoutes = [ '/login', '/contactrep', '/forgot-password','/stripeLinkPayment']
        if ((settings && (settings.isCatalogueMode === true || settings.isInvalidPlugableMode === true)) || (location && allowedAnonymousRoutes.some(x => location.pathname.includes(x) )))
        {
            return true;
        }
        const { user } = this.props;
        // This line is added to fix the an inital case where the user is cached as Authenticated but it is invalid session since the Authentication was from expired session
        let isUserAuthenticated = user.isAuthenticated;
        if(checkSessionValidity) {
            isUserAuthenticated = settings.isValidSession ? user.isAuthenticated : false;
        }
        if (settings && settings.allowAnonymouse === false && isUserAuthenticated !== true) {
            this.props.history.push(`${settings.baseUrl}login`);
            return false;
        }
        return true;
    }

    onRouteChange(location) {
        const { settings } = this.props;
        this.checkAnonymouse(settings, location);
        if (window.ga) {
            window.ga('set', 'page', location.pathname);
        }
        if (window.gtag) {
            window.gtag('config', settings.googleTagManagerId, { 'page_path': location.pathname });
        }
    }

    initTranslationI18n(locale) {
        const i18n = i18nInit(locale);
        this.setState({ i18n: i18n });
    }

    loadTranslation(locale) {
        // if (locale in sessionStorage) {
        if (utils.isNullOrEmpty(sessionStorage.getItem(locale)) === false) {
            this.setState({ hasTranslationLoaded: true });
            this.initTranslationI18n(locale);
            return;
        }

        this.props.getTranslations(locale).then((transResponse) => {
            if (transResponse && transResponse.value.status === 200 && transResponse.value.data) {
                var translationArr = transResponse.value.data;
                const translationObj = translationArr.reduce((obj, item) => {
                    return { ...obj, [item.ResourceId]: item.Value };
                }, {});
                if (_.isEmpty(translationObj) === false) {
                    sessionStorage.setItem(locale, JSON.stringify(translationObj));
                }
            }
            this.setState({ hasTranslationLoaded: true });
            this.initTranslationI18n(locale);
        }, (error) => { });
    }

    componentDidMount() {


        this.props.history.listen(this.onRouteChange.bind(this));

        this.props.getActiveSettings().then((response) => {
            if (response && response.value.status === 200 && response.value.data) {

                // load user cart if loggedin
                const { user } = this.props;
                if (user.isAuthenticated === true && utils.isNullOrEmpty(user.userId) === false) {
                    this.props.getCart(user.userId, null, true).then((response) => { }, (error) => { });
                }

                const settings = response.value.data;

                const initialLocale = utils.isNullOrEmpty(this.props.locale) ? settings.locale : this.props.locale;
                if (this.state.hasTranslationLoaded === true) {
                    this.initTranslationI18n(initialLocale);
                } else {
                    this.loadTranslation(initialLocale);
                }

                document.documentElement.classList.add(settings.supplierCode.toLowerCase());
                var canViewAnonymouse = true;
                if (settings.isCatalogueMode !== true) {
                    canViewAnonymouse = this.checkAnonymouse(settings, this.props.history.location, true);
                }
                else {
                    document.documentElement.classList.add('catalogue-mode');

                }

                if (canViewAnonymouse) {
                    this.props.getSiteLinks().then((response) => { }, (error) => { });

                    if (settings.isOpenpayEnabled === true) {
                        this.registerOpenpayWidgets(settings);
                    }
                }

            } else {
                console.log('Failed to load settings');
            }
        }, (error) => {
            console.log(error);
        });

    }


    render() {
        const { settings, locale, showLoader, user } = this.props;
        const { hasTranslationLoaded, i18n } = this.state;

        if (!settings || !locale || !hasTranslationLoaded || !i18n)
            return <Spinner showLoader={true} />;

        if (settings.noShop === true) {
            return (
                <Suspense fallback={<Spinner />}>
                    <I18nextProvider i18n={i18n}>
                        <AccessDeniedNoHeader />
                    </I18nextProvider>
                </Suspense>
            );
        }

        const canViewAnonymouse = (settings.allowAnonymouse === false && user.isAuthenticated !== true) === false;

        let appComponents = null;
       
        if (settings.isCatalogueMode === true) {
            appComponents = (
                <Fragment>
                    <Spinner showLoader={showLoader} />
                    <SideMenu />
                    <UserErrors />
                    <AppCatalogueRoutes key={locale} settings={settings} />
                </Fragment>
            )
        } else {
            const regAnalytictsCallback = () => this.registerAnalytics(settings);
            const cookieConfig = getCookieConfig(i18n, regAnalytictsCallback, regAnalytictsCallback);
            if (settings && settings.isInvalidPlugableMode === true) {
                appComponents = <AccessDeniedView />
            } else if (user.representative && user.representative.showContanctHeadOfficeMessage) {
                appComponents = <HeadofficeMessage />
            } else {
                appComponents = (
                    <Fragment>
                        <Spinner showLoader={showLoader} />
                        {canViewAnonymouse && <SideMenu />}
                        <TopBar />
                        <UserErrors />  
                        <AppRoutes key={locale} settings={settings} /> {/* This key is simply to re-render all routes components when the local changes and reload all data*/}
                        {settings.showCookieConsent && <CookieConsent config={cookieConfig} />}
                        <Footer />
                    </Fragment>
                );
            }
        }

        return (
            <Suspense fallback={<Spinner />}>
                <I18nextProvider i18n={i18n}>
                    <BreakpointProvider>
                        <div className="App" ref={this.containerRef} style={{ position: 'relative' }}>
                            {settings.isCatalogueMode && <ResizeObserver
                                onResize={(rect) => {
                                    //console.log('Resized. New bounds:', rect.width, 'x', rect.height);
                                    if (window && window.parent) {
                                        window.parent.postMessage({ message: 'schange', nh: rect.height, nw: rect.width }, '*');
                                    }
                                }}
                                onReflow={(rect) => {
                                    // console.log('Resized. New bounds:', rect.width, 'x', rect.height);
                                    if (window && window.parent) {
                                        window.parent.postMessage({ message: 'schange', nh: rect.height, nw: rect.width }, '*');
                                    }
                                }}
                            />}
                            <ScrollToTop>
                                <Helmet>
                                    {settings.metaTitle && <title data-react-helmet="true">{settings.metaTitle}</title>}
                                    {settings.metaDescription && <meta name="description" content={settings.metaDescription} data-react-helmet="true" />}
                                    {settings.metaFacebookVerification && <meta name="facebook-domain-verification" content={settings.metaFacebookVerification} data-react-helmet="true" />}
                                    {settings.metaPinterestVerification && <meta name="p:domain_verify" content={settings.metaPinterestVerification} data-react-helmet="true" />}
                                    {settings.metaGoogleVerification && <meta name="google-site-verification" content={settings.metaGoogleVerification} data-react-helmet="true" />}
                                </Helmet>
                                {appComponents}
                            </ScrollToTop>

                        </div>
                    </BreakpointProvider>
                </I18nextProvider>
            </Suspense>
        );
    }
}



function mapStateToProps({ locale, user, settings, error, showLoader }) {
    return { locale, user, settings, error, showLoader };
}

export default withRouter(connect(mapStateToProps, { getActiveSettings, getSiteLinks, /*initCatalogue,*/ getCart, saveCart, getTranslations })(App));


//export default App;
